<template>
  <v-toolbar ref="toolbar" dense>
    <!-- <v-btn icon class="hidden-xs-only" @click.prevent="backButtonClick">
      <v-icon>arrow_back</v-icon>
    </v-btn> -->
    <v-toolbar-title ref="title">
      <div
        class="d-inline-flex links-wrapper"
        v-for="(route, index) in getHistory"
        :key="index"
      >
        <span
          class="link"
          :title="generateTitle(route)"
          @click="navigateBack(index)"
        >
          <div ref="regular-view" v-show="!showIcons && !showSmallIcons">
            <span>
              {{ route.text }}
            </span>
            <span class="font-weight-bold">
              {{ route.name }}
            </span>
          </div>
          <div ref="icon-view" v-show="showIcons && !showSmallIcons">
            <Icon
              :icon="getIcon(route.text)"
              style="font-size: 26px; margin-bottom: -5px"
            />
            <span class="font-weight-bold">
              {{ route.name }}
            </span>
          </div>
          <div v-show="showIcons && showSmallIcons">
            <Icon
              :icon="getIcon(route.text)"
              style="font-size: 26px; margin-bottom: -5px"
            />
          </div>
          <!-- <span v-if="!showIcons">
            {{route.text}}
          </span>
          <Icon v-else :icon="getIcon(route.text)" style="font-size: 26px; margin-bottom: -5px;" />
          <span v-if="!showSmallIcons" class="font-weight-bold">
            {{route.name}}
          </span> -->
        </span>
        <span class="ml-2 mr-2" v-if="getHistory[index + 1]">/</span>
      </div>
      <resize-observer @notify="handleResizeChild" />
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <resize-observer @notify="handleResizeParent" />
  </v-toolbar>
</template>

<script>
import { Icon } from '@iconify/vue2'
import { mapGetters } from 'vuex'
export default {
  props: {
    source: String,
    title: String,
    items: Array
  },

  components: {
    Icon
  },

  data() {
    return {
      showIcons: false,
      showSmallIcons: false
    }
  },

  created() {
    this.$vuetify.theme.dark = true
  },

  mounted() {
    this.handleResize()
  },

  methods: {
    handleResizeChild({ width, height }) {
      this.handleResize()
    },
    handleResizeParent({ width, height }) {
      this.handleResize()
    },
    handleResize() {
      if (
        this.$refs.title.clientWidth >
        this.$refs.toolbar.$el.clientWidth - 81
      ) {
        if (this.showIcons) {
          this.showSmallIcons = true
        }
        this.showIcons = true
      } else {
        this.checkResizeBack()
      }
    },
    checkResizeBack() {
      console.log('checking resize back')
      // if small view check if icon view could fit and set it
      if (this.showSmallIcons) {
        this.showIcons = true
        this.showSmallIcons = false
        this.$nextTick(() => {
          let iconView = 0
          for (var i = 0; i < this.$refs['icon-view'].length; i++) {
            iconView += this.$refs['icon-view'][i].clientWidth + 20
          }
          if (iconView < this.$refs.toolbar.$el.clientWidth - 81) {
            this.showSmallIcons = false
            this.showIcons = true
          } else {
            this.showIcons = true
            this.showSmallIcons = true
          }
        })
        return
      }
      // if icon view check if long view could fit and set it
      if (this.showIcons) {
        this.showIcons = false
        this.showSmallIcons = false
        this.$nextTick(() => {
          let regView = 0
          for (var i = 0; i < this.$refs['regular-view'].length; i++) {
            regView += this.$refs['regular-view'][i].clientWidth + 20
          }
          if (regView < this.$refs.toolbar.$el.clientWidth - 81) {
            this.showIcons = false
            this.showSmallIcons = false
            return
          } else {
            this.showIcons = true
            this.showSmallIcons = false
          }
        })
      }
    },
    navigateBack(index) {
      console.log(index, this.getHistory.length)
      if (index < this.getHistory.length - 1) {
        this.$router.go(0 - (this.getHistory.length - (index + 1)))
        // this.$store.dispatch(
        //   'BreadcrumbsStore/goBack',
        //   this.getHistory.length - (index + 1),
        //   { root: true }
        // )
      }
    },
    backButtonClick: function(event) {
      var path = event.path || (event.composedPath && event.composedPath())
      if (path) {
        // You got some path information
        path[1].blur()
        this.$router.go(-1)
      } else {
        // This browser doesn't supply path information
        this.$store.dispatch(
          'NotificationStore/add',
          {
            type: 'error',
            message: `Not supported by the browser.`
          },
          { root: true }
        )
      }
    }
  },
  computed: {
    ...mapGetters('BreadcrumbsStore', ['getHistory']),
    getIcon() {
      return context => {
        let str = 'emojione-monotone:letter-'
        let letter = context.substr(0, 1).toLowerCase()
        return str + letter
      }
    },
    generateTitle() {
      return route => {
        let str = route.text + route.name
        return str
      }
    }
  },
  watch: {
    '$store.state.BreadcrumbsStore.history': function() {
      console.log('handle resize')
      this.handleResize()
    }
  }
}
</script>

<style scoped lang="scss" media="screen">
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 4em;
  z-index: 2;
}
.v-toolbar__title {
  position: relative !important;
}
.link {
  cursor: pointer;
}
.link div:hover {
  color: var(--v-primary-base);
}
.link:last-child div:hover {
  color: white;
  cursor: default;
}
.link div {
  transition-duration: 0.3s;
}
</style>
